/**
 * 封装退出登录时检查上传/下载任务并弹窗提示
 */

import CustomDialog from '@/renderer/scripts/utils/CustomDialog';
import { IS_BROWSER } from '@/common/constant';
import uploadTaskManager from '@/renderer/scripts/utils/upload/index';
import downloadTaskManager from '@/renderer/scripts/utils/download/index';
import i18n, { i18n_t } from '@/locales/i18n';

type CheckTransAndsignOut = {
  type?: 'signOut' | 'switchOrg' | 'quit';
  className?: string;
  alwaysShowDialog?: boolean;
  foundRunningTaskFn?: Function;
  confirmFn?: Function;
  cancelFn?: Function;
  closeFn?: Function;
  noRunningTaskFn?: Function;
};

type InitDialog = {
  header?: string;
  body?: string;
  className?: string;
  confirmFn?: Function;
  cancelFn?: Function;
  closeFn?: Function;
};

// 检查是否存在没有结束的上传/下载任务
export function checkRunningTask() {
  const hasRunningUploadTask = uploadTaskManager.existUnfinishedTask();
  if (hasRunningUploadTask) return true;
  const hasRunningDownloadTask = downloadTaskManager.existUnfinishedTask();
  return hasRunningDownloadTask;
}

function initDialog({ header, body, className, confirmFn, cancelFn, closeFn }: InitDialog) {
  const dialog = CustomDialog.confirm({
    theme: 'warning',
    header,
    body,
    className,
    width: '400px',
    async onConfirm() {
      if (dialog.hide) {
        dialog.hide();
      }
      confirmFn && confirmFn();
    },
    onCancel() {
      cancelFn && cancelFn();
    },
    onClosed() {
      closeFn && closeFn();
    },
  });
}

const headerMap = {
  signOut: i18n_t('退出登录'),
  switchOrg: i18n_t('切换身份'),
  quit: i18n_t('退出'),
};

const getBodyTip = (type: string, action: string) => {
  if (type === 'quit') return i18n_t('有上传或下载任务尚未完成，确定要退出程序吗？');
  if (type === 'signOut') return i18n_t('有上传或下载任务未完成，确定要{action}并注销登录吗？', { action });
  if (type === 'switchOrg') return i18n_t('上传或下载任务未完成，切换后任务将被{action}，确认切换吗？', { action });
  return i18n_t('确定要退出登录吗？');
};

// 退出登录前检查并提示
export function checkTransBeforeQuit({
  type = 'signOut',
  className,
  alwaysShowDialog,
  foundRunningTaskFn,
  confirmFn,
  cancelFn,
  closeFn,
  noRunningTaskFn,
}: CheckTransAndsignOut) {
  const header = headerMap[type];
  let body = i18n_t('确定要退出登录吗？');
  const existRunningTask = checkRunningTask();
  if (existRunningTask) {
    foundRunningTaskFn && foundRunningTaskFn();
    const action = i18n_t('清空');
    body = getBodyTip(type, action);
    initDialog({ header, body, className, confirmFn, closeFn });
  } else {
    if (alwaysShowDialog) {
      initDialog({ header, body, className, confirmFn, cancelFn, closeFn });
    }
    noRunningTaskFn && noRunningTaskFn();
  }
}
